const DISPLAY_NAME_KEY = 'bf_display_name';

export function getStoredDisplayName(): string {
  try {
    return localStorage.getItem(DISPLAY_NAME_KEY) || '';
  } catch {
    return '';
  }
}

export function saveDisplayName(name: string) {
  try {
    localStorage.setItem(DISPLAY_NAME_KEY, name.trim());
  } catch {
    /* ignore */
  }
}
